"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.phoneNumberDescription = void 0;
const libphonenumber_js_1 = __importDefault(require("libphonenumber-js"));
const formatPhone_1 = require("../util/formatPhone");
const InvalidResult_1 = __importDefault(require("./InvalidResult"));
const String_1 = require("./String");
const ValidationResult_1 = require("./ValidationResult");
exports.phoneNumberDescription = Object.assign(Object.assign({}, (0, String_1.stringDescription)()), { userFacingTitle: 'phone', userFacingValue: formatPhone_1.formatPhone, validate(value) {
        return (0, ValidationResult_1.validationResultTry)((0, String_1.stringDescription)().validate(value), string => {
            const phoneNumber = (0, libphonenumber_js_1.default)(string, 'US');
            if (!phoneNumber || !phoneNumber.isValid()) {
                return new InvalidResult_1.default(`Invalid phone phoneNumber: ${phoneNumber}`);
            }
            return string;
        });
    } });
